import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=77565815"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports